import React, { useEffect, useState } from 'react';
import { basicsettinglist, getActiveplancategorys, getactiveplansbycategory, homebannerupdate } from '../../../Services/Admin/Admin';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';
import Loader from "../../../../Utils/Loader";
import { image_baseurl } from '../../../../Utils/config';

const HomeBannerUpdate = () => {
    const token = localStorage.getItem('token');
    const [clients, setClients] = useState(null);
    const [categories, setCategories] = useState([]);
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    const getsettingdetail = async () => {
        try {
            const response = await basicsettinglist(token);
            if (response.status) {
                setClients(response.data);
                if (response.data[0]?.bannercategoryid) {
                    getPlans(response.data[0].bannercategoryid);
                }
            }
        } catch (error) {
            console.log('Error fetching settings:', error);
        }
    };

    const getCategories = async () => {
        try {
            const response = await getActiveplancategorys(token);
            if (response.status) {
                setCategories(response.data);
            }
        } catch (error) {
            console.log('Error fetching categories:', error);
        }
    };

    const getPlans = async (categoryId) => {
        try {
            const response = await getactiveplansbycategory(categoryId, token);
            if (response.status) {
                setPlans(response.data);
            } else {
                setPlans([]);
            }
        } catch (error) {
            console.log('Error fetching plans:', error);
            setPlans([]);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await Promise.all([getsettingdetail(), getCategories()]);
            setLoading(false);
        };
        fetchData();
    }, []);

    const validationSchema = Yup.object().shape({
        bannerstatus: Yup.string().required('Banner Status is required'),
        bannercategoryid: Yup.string().required('Banner Category is required'),
        bannerplanid: Yup.string().required('Banner Plan is required'),
        banneruser_type: Yup.string().required('Banner User Type is required'),
        // bannerimage: Yup.mixed().required('Banner Image is required'),
    });

    if (loading || !clients) {
        return <div><Loader /></div>;
    }

    return (
        <div className='page-content'>
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Home Banner Update</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-8 mx-auto">
                    <div className="card radius-15">
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                bannerstatus: String(clients[0].bannerstatus ?? 0),
                                bannercategoryid: clients[0].bannercategoryid ?? "",
                                bannerplanid: clients[0].bannerplanid ?? "",
                                banneruser_type: clients[0].banneruser_type ?? 2,
                                bannerimage: null,
                            }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { setSubmitting }) => {
                                const req = {
                                    bannerstatus: Number(values.bannerstatus),
                                    bannercategoryid: values.bannercategoryid,
                                    bannerplanid: values.bannerplanid,
                                    banneruser_type: Number(values.banneruser_type),
                                };
                                if (values.bannerimage) {
                                    req.bannerimage = values.bannerimage;
                                }

                                try {
                                    const response = await homebannerupdate(req, token);
                                    if (response.status) {
                                        showCustomAlert("Success", "Home Banner updated successfully");
                                        getsettingdetail();
                                    } else {
                                        showCustomAlert("error", response.message);
                                    }
                                } catch (error) {
                                    showCustomAlert("error", "An unexpected error occurred. Please try again later.");
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ isSubmitting, setFieldValue, values }) => (
                                <Form className="card-body">
                                    <div className='p-4 border radius-15'>
                                        <div className="row">
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-6">
                                                    <label htmlFor="bannerstatus" className="col-form-label">
                                                        <b>Banner Status</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="bannerstatus"
                                                        className="form-control custom-select"
                                                    >
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </Field>
                                                    <ErrorMessage name="bannerstatus" component="div" className="error" />
                                                </div>

                                                <div className="col-sm-6">
                                                    <label htmlFor="banneruser_type" className="col-form-label">
                                                        <b>Banner User Type</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="banneruser_type"
                                                        className="form-control custom-select"
                                                    >
                                                        <option value="2">All Users</option>
                                                        <option value="1">Old Users</option>
                                                        <option value="0">New Users</option>
                                                    </Field>
                                                    <ErrorMessage name="banneruser_type" component="div" className="error" />
                                                </div>
                                            </div>

                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-6">
                                                    <label htmlFor="bannercategoryid" className="col-form-label">
                                                        <b>Banner Category</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="bannercategoryid"
                                                        className="form-control custom-select"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setFieldValue('bannercategoryid', value);
                                                            setFieldValue('bannerplanid', "");
                                                            getPlans(value);
                                                        }}
                                                    >
                                                        <option value="">Select Category</option>
                                                        {categories.map((cat) => (
                                                            <option key={cat._id} value={cat._id}>{cat.title}</option>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name="bannercategoryid" component="div" className="error" />
                                                </div>

                                                <div className="col-sm-6">
                                                    <label htmlFor="bannerplanid" className="col-form-label">
                                                        <b>Banner Plan</b>
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="bannerplanid"
                                                        className="form-control custom-select"
                                                    >
                                                        <option value="">Select Plan</option>
                                                        {plans.map((plan) => (
                                                            // <option key={plan._id} value={plan._id}>{plan.validity}{plan.price}</option>
                                                            <option key={plan._id} value={plan._id}>
                                                                {plan.validity} {" "} ₹{plan.price}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name="bannerplanid" component="div" className="error" />
                                                </div>
                                            </div>

                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-6">
                                                    <label htmlFor="bannerimage" className="col-form-label">
                                                        <strong>Banner Image</strong> <span>(2000w × 225h)</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        name="bannerimage"
                                                        accept="image/*"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            const file = event.currentTarget.files[0];
                                                            if (file) {
                                                                if (!file.type.startsWith('image/')) {
                                                                    showCustomAlert("error", "Only image files are allowed.");
                                                                    setFieldValue("bannerimage", null);
                                                                    event.target.value = "";
                                                                    return;
                                                                }
                                                                const img = new Image();
                                                                const objectUrl = URL.createObjectURL(file);
                                                                img.src = objectUrl;
                                                                img.onload = () => {
                                                                    URL.revokeObjectURL(objectUrl);
                                                                    if (img.width !== 2000 || img.height !== 225) {
                                                                        showCustomAlert("error", "Image dimensions must be exactly 2000w x 225h.");
                                                                        setFieldValue("bannerimage", null);
                                                                        event.target.value = "";
                                                                    } else {
                                                                        setFieldValue("bannerimage", file);
                                                                    }
                                                                };
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name="bannerimage" component="div" className="error" />
                                                </div>
                                                {clients[0].bannerimage && (
                                                    <div className="col-sm-6 mt-4">
                                                        <img
                                                            src={`${image_baseurl}uploads/basicsetting/${clients[0].bannerimage}`}
                                                            alt="Banner"
                                                            style={{ width: '100px', height: 'auto' }}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-sm-12 mt-3 text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <style jsx>{`
                            .error {
                                color: red;
                                font-size: 15px;
                            }
                            .custom-select {
                                appearance: none;
                                background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="34" viewBox="0 0 24 24"><path fill="gray" d="M7 10l5 5 5-5z"/></svg>') no-repeat right center;
                                background-size: 1em;
                                padding-right: 1.5em;
                            }
                        `}</style>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBannerUpdate;
